// extracted by css-extract-rspack-plugin
export default {"successScreen":"successScreen-kPsRGw","recipientRow":"recipientRow-WTozpA","recipientText":"recipientText-nRGuM5","viewConversationLink":"viewConversationLink-VzvHqo"};